import { PropsWithChildren, ReactElement } from "react";
import styles from "./SubNavigationBody.module.less";

export const SubNavigationBody = (props: PropsWithChildren<{}>): ReactElement => {
	const {
		children
	} = props;

	return (
		<div className={styles.root}>
			{children}
		</div>
	);
};
SubNavigationBody.displayName = "SubNavigation.Body";